<!--
 * @Description:
 * @version: V1.0.0
 * @Author: xiaoxiao
 * @Date: 2020-10-03 11:13:21
-->
/*
创建者 魏强(2018.1.24)
首页banner
*/
<template>
  <div class="focus-warp">
    <carousel
      :data="list"
      :pcXrsdGoodsAdv="pcXrsdGoodsAdv"
    ></carousel>
    <!-- <flashNewsList :data="newData" :adv="rightAdv"></flashNewsList> -->
  </div>
</template>
<script>
import carousel from './carousel.vue';
import flashNewsList from './flashNewsList.vue';
import {parseAdvList} from 'utils/tool.js';
export default {
  components:{
    carousel,
    flashNewsList
  },
  props: [
    'bannerData',
    'newData',
    'rightAdv',
    'pcXrsdGoodsAdv',
  ],
  data () {
    return {
        list:parseAdvList(this.bannerData)
    }
  },
  created(){
    console.log(this.list, '-----------------------------');
  }
}
</script>
<style scoped>
.focus-warp{
  height: 588px;
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// index.vue?45ae1039